import App from './App';
import { NAME } from './constants';
import reducer from './reducer';
import * as actions from './actions';

export default {
  NAME,
  App,
  reducer,
  actions,
};
